<template>
    <div style="position: relative; width: 100%">
        <div style="position: absolute; bottom: 0; width: 100%">
            <div style="overflow: hidden; width: 30%; margin: auto">
                <router-link to="/about_us"><div class="bottom_nav_items" style="color: #333333">关于我们</div></router-link>
                <router-link to="/service_support"><div class="bottom_nav_items">服务与支持</div></router-link>
                <router-link to="/ordering_guide"><div class="bottom_nav_items">订购指南</div></router-link>
                <router-link to="/reference_material"><div class="bottom_nav_items">参考资料</div></router-link>
                <router-link to="/return_policy"><div class="bottom_nav_items">退换货流程说明</div></router-link>
            </div>

            <div style="overflow: hidden; width: 40%; margin: 20px auto; text-align: center">Copyright© 2018-2020eBiotrade.com, All Rights Reserved <a href="https://www.beian.gov.cn/portal/recordQuery?token=49ff9b83-b5e4-4aff-9b7e-901f026e10ae" target="_blank" style="color: #2c3e50">川公网安备 51018302000037号</a> <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #666">蜀ICP备14015738号-4</a></div>
        </div>
        <!--
                  <div style="overflow: hidden;">
        <router-link to="/about_us"><div class="box1026">关于我们</div></router-link>
        <router-link to="/service_support"><div class="box1026">服务与支持</div></router-link>
        <router-link to="/ordering_guide"><div class="box1026">订购指南</div></router-link>
      </div>
      <div style="overflow: hidden; margin-top: 2%;">
        <router-link to="/reference_material"><div class="box1026">参考资料</div></router-link>
        <router-link to="/return_policy"><div class="box1026">退换货流程说明</div></router-link>
      </div>
         -->
    </div>
</template>

<script>
export default {
    name: 'App'
};
</script>

<style scoped>
.bottom_nav_items {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666;
    text-align: center;
    width: 20%;
    float: left;
}
.top_title1 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    float: left;
    margin-left: 2%;
}
.login_lianxifangshi {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
}
</style>



// WEBPACK FOOTER //
// src/public/login_foot.vue